import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { registerLocale } from 'react-datepicker';
import swal from 'sweetalert';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as EventsActions, Selectors as EventsSelectors } from 'store/ducks/events';

import { Access } from 'common';
import { Form, Loading } from 'components';

import ptBr from 'date-fns/locale/pt-BR';
registerLocale('pt-BR', ptBr);

class CustomForm extends Component {
  static defaultProps = {
    edit: false,
  };

  state = {
    data: this.props.data,
    price_points: false,
  };

  componentDidMount() {
    const {
      data,
      getEventsLocalRequest,
      getEventsTypesRequest,
      getEventDifficultiesRequest,
      getEventsPlansRequest,
    } = this.props;

    getEventsLocalRequest();
    getEventsTypesRequest();
    getEventDifficultiesRequest();
    getEventsPlansRequest();

    this.setState({ price_points: data.price_points !== null });
  }

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleChangeInput = e => {
    const { name, value } = e.target;
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleChangePricePoints = e => {
    const { value } = e.target;

    this.setState({ price_points: value === 'true' ? true : false });
  };

  handleChangeDate = (name, value) => {
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleToggleActive = () => {
    const { data } = this.state;

    this.setState({ data: { ...data, active: !data.active } });
  };

  handleSelectLocals = local => {
    const { data } = this.state;

    this.setState({ data: { ...data, local } });
  };

  handleSelectTypes = type => {
    const { data } = this.state;

    this.setState({ data: { ...data, type } });
  };

  handleSelectDifficulties = difficulty => {
    const { data } = this.state;

    this.setState({ data: { ...data, difficulty } });
  };

  handleSelectPlans = experience_plan_ids => {
    const { data } = this.state;

    this.setState({ data: { ...data, experience_plan_ids } });
  };

  handleApprove = async () => {
    const { data } = this.state;
    const { approveEventRequest } = this.props;

    const approve = await swal({
      title: 'Aprovar Evento',
      text: 'Deseja mesmo aprovar?',
      buttons: {
        cancel: 'Cancelar',

        confirm: {
          text: 'Sim, aprovar',
        },
      },
    });

    !!approve && approveEventRequest(data.id);
  };

  handleRepprove = async () => {
    const { data } = this.state;
    const { repproveEventRequest } = this.props;

    const obs = await swal({
      title: 'Reprovar Evento',
      text: '',
      content: {
        element: 'input',
        attributes: {
          value: '',
          placeholder: 'Descreva o motivo',
        },
      },
      buttons: {
        cancel: 'Cancelar',

        confirm: {
          text: 'Reprovar',
        },
      },
    });

    if (obs === '') {
      await swal('Você precisa adicionar uma observação para reprovar o evento', '', 'error');
      this.handleRepprove();
    } else if (obs !== null) {
      repproveEventRequest(data.id, { voucher: { obs } });
    }
  };

  handleSave = e => {
    e.preventDefault();

    const { onSave } = this.props;
    onSave();
  };

  render() {
    const { data, price_points } = this.state;
    const { errors, saving, locals, edit, types, plans, difficulties, approve, repprove } = this.props;

    return (
      <Form className="page-form">
        <h3 className="form-title">Detalhes do Evento</h3>

        {data.event_status === 'reproved' && (
          <div className="alert alert-warning">
            <h4>Reprovado</h4>

            {data.event_status_obs}
          </div>
        )}

        <Form.Field>
          <Form.Label>Título</Form.Label>
          <Form.Input
            name="name"
            placeholder="Jardinagem e horta em espaços pequenos"
            value={data.name}
            onChange={this.handleChangeInput}
            errors={errors.name}
          />
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Tipo de evento {data.type_id}</Form.Label>
          <Form.Select
            placeholder="Selecione um tipo de evento"
            onChange={this.handleSelectTypes}
            value={data.type}
            options={types.data}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Descrição</Form.Label>
          <Form.TextArea
            name="description"
            placeholder="Workshop de jardinagem e hortas em espaços pequenos. Como cultivar mudas em sua casa, de ervas frescas até frutas. Tecnicas para manter sua horta sempre cuidada"
            value={data.description}
            onChange={this.handleChangeInput}
            errors={errors.description}
          />
        </Form.Field>

        <div className="form-section">
          <h4 className="form-section-title">Período de Inscrição</h4>
          <span className="form-section-description">
            Período em que será disponível ser feita a inscrição do evento.
          </span>

          <div className="form-section-collapse open">
            <Form.Field className="datepicker-field">
              <Form.Label>Início das Inscrições</Form.Label>
              <Form.DatePicker
                locale="pt-BR"
                selected={data.date_sale_start}
                onChange={value => this.handleChangeDate('date_sale_start', value)}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={1}
                dateFormat="dd/MM/yyyy HH:mm"
                timeCaption="time"
                errors={errors.date_sale_start}
              />
              <div className="icon-input">
                <span className="glyph glyph-calendar" />
              </div>
            </Form.Field>

            <Form.Field className="datepicker-field">
              <Form.Label>Fim das Inscrições</Form.Label>
              <Form.DatePicker
                locale="pt-BR"
                selected={data.date_sale_end}
                onChange={value => this.handleChangeDate('date_sale_end', value)}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={1}
                dateFormat="dd/MM/yyyy HH:mm"
                timeCaption="time"
                errors={errors.date_sale_end}
              />
              <div className="icon-input">
                <span className="glyph glyph-calendar" />
              </div>
            </Form.Field>
          </div>
        </div>

        <div className="form-section">
          <h4 className="form-section-title">Período do Evento</h4>
          <span className="form-section-description">Data e Hora que ocorrerá o evento.</span>

          <div className="form-section-collapse open">
            <Form.Field className="datepicker-field">
              <Form.Label>Início do Evento</Form.Label>
              <Form.DatePicker
                locale="pt-BR"
                selected={data.date}
                onChange={value => this.handleChangeDate('date', value)}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={1}
                dateFormat="dd/MM/yyyy HH:mm"
                timeCaption="time"
                errors={errors.date}
              />
              <div className="icon-input">
                <span className="glyph glyph-calendar" />
              </div>
            </Form.Field>

            <Form.Field className="datepicker-field">
              <Form.Label>Fim do Evento</Form.Label>
              <Form.DatePicker
                locale="pt-BR"
                selected={data.date_end}
                onChange={value => this.handleChangeDate('date_end', value)}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={1}
                dateFormat="dd/MM/yyyy HH:mm"
                timeCaption="time"
                errors={errors.date_end}
              />
              <div className="icon-input">
                <span className="glyph glyph-calendar" />
              </div>
            </Form.Field>
          </div>
        </div>

        <Form.Field className="field-select">
          <Form.Label>Local</Form.Label>
          <Form.Select
            placeholder="Selecione um local"
            onChange={this.handleSelectLocals}
            value={data.local}
            options={[{ value: '', label: 'Não Será na Loja' }, ...locals.data]}
            isDisabled={!!Access.lockedStore()}
          />
        </Form.Field>

        {data.local.value === '' && (
          <Form.Field>
            <Form.Label>Local Alternativo (Caso não for na loja)</Form.Label>
            <Form.Input
              name="alternative_location"
              placeholder="Local Alternativo"
              value={data.alternative_location}
              onChange={this.handleChangeInput}
            />
          </Form.Field>
        )}

        <Form.Field>
          <Form.Label>Total de Vagas</Form.Label>
          <Form.Input
            name="vacancy"
            placeholder="35"
            value={data.vacancy}
            onChange={this.handleChangeInput}
            errors={errors.vacancy}
          />
        </Form.Field>

        {Access.hasPermissions('manage-events-invites') && edit && !!data.canInvite && (
          <Form.Field>
            <Form.Label>Convites</Form.Label>
            <div className="buttons-invites">
              <Link to={`/events/${data.id}/invite`}>
                <Form.Button className="button-invite">Enviar Convites</Form.Button>
              </Link>
              <Form.Label className="label-invite">Convites Enviados</Form.Label>
            </div>
          </Form.Field>
        )}

        {Access.hasPermissions('manage-events-attendance') && edit && (
          <Form.Field>
            <Form.Label>Inscritos</Form.Label>
            <div className="buttons-invites">
              <Link to={`/events/${data.id}/attendances`}>
                <Form.Button className="button-invite-space">Lista de Presentes</Form.Button>
              </Link>
              <Form.Label className="label-invite">{data.number_confirmeds} Inscritos</Form.Label>
            </div>
          </Form.Field>
        )}

        <Form.Field className="radio-field">
          <Form.Label>Custo em Pontos do evento</Form.Label>

          <Form.Label className="radio">
            <Form.Input
              name="price_points"
              type="radio"
              value="false"
              className="none-class"
              onChange={this.handleChangePricePoints}
              checked={price_points ? false : true}
            />
            Não disponivel
          </Form.Label>

          <Form.Label className="radio">
            <Form.Input
              name="price_points"
              type="radio"
              value="true"
              className="none-class"
              onChange={this.handleChangePricePoints}
              checked={price_points ? true : false}
            />

            {price_points ? (
              <Form.Input
                name="price_points"
                placeholder="Insira a quantidade desejada"
                onChange={this.handleChangeInput}
                value={data.price_points}
                type="number"
              />
            ) : (
              'Definir Quantidade'
            )}
          </Form.Label>
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Dificuldade</Form.Label>
          <Form.Select
            placeholder="Selecione dificuldade"
            onChange={this.handleSelectDifficulties}
            value={data.difficulty}
            options={difficulties.data}
          />
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Plano</Form.Label>
          <Form.Select
            isMulti
            placeholder="Selecione planos"
            onChange={this.handleSelectPlans}
            value={data.experience_plan_ids}
            options={plans.data}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Responsavel do evento</Form.Label>
          <Form.Input
            name="alias_speaker"
            placeholder="Nome do responsável do evento"
            value={data.alias_speaker}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <div className="buttons">
          <Link to="/events/list" className="button-cancel">
            Cancelar
          </Link>

          {Access.hasPermissions('approve-events') && edit && data.event_status !== 'reproved' && (
            <Form.Button type="button" className="button-cancel" onClick={this.handleRepprove} disabled={saving}>
              {repprove.loading ? <Loading type="btn" size="small" text="Reprovando..." /> : 'Reprovar'}
            </Form.Button>
          )}

          {Access.hasPermissions('approve-events') && edit && data.event_status !== 'approve' && (
            <Form.Button
              type="button"
              className="button-save margin-right-15"
              onClick={this.handleApprove}
              disabled={saving}
            >
              {approve.loading ? <Loading type="btn" size="small" text="Aprovando..." /> : 'Aprovar'}
            </Form.Button>
          )}

          {data.event_status !== 'reproved' && (
            <Form.Button className="button-save" onClick={this.handleSave} disabled={saving}>
              {saving ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
            </Form.Button>
          )}
        </div>
      </Form>
    );
  }
}

const mapState = state => ({
  events: state.events,
  locals: {
    ...state.events.locals,
    data: EventsSelectors.locals(state.events.locals.data),
  },
  types: {
    ...state.events.types,
    data: EventsSelectors.types(state.events.types.data),
  },
  plans: {
    ...state.events.plans,
    data: EventsSelectors.plans(state.events.plans.data),
  },
  difficulties: {
    ...state.events.difficulties,
    data: EventsSelectors.difficulties(state.events.difficulties.data),
  },
  approve: state.events.approve,
  repprove: state.events.repprove,
});

const mapActions = dispatch => bindActionCreators(EventsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(CustomForm);
